<div class="bodyHeight">
  <div *ngIf="!successMsg">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-6 col-lg-offset-5 col-xl-5">
          <div class="img-out">
                   </div>
          <div class="border forBoarder">
            <div class="login-lable">
              <div class="text-center login-title">CREATE PASSWORD</div>
            </div>
            <form class="forForm" [formGroup]="createPasswordForm">
              <div class="form-group">
                <input
                  type="password"
                  placeholder="New Password"
                  formControlName="password"
                  class="form-control email-input"
                  name="password"
                  required
                />
                <div
                  *ngIf="
                    createPasswordForm.get('password').hasError('required') &&
                    createPasswordForm.get('password').touched
                  "
                >
                  <div class="error">Please enter new password</div>
                </div>
                <div
                  *ngIf="
                    createPasswordForm.get('password').hasError('minlength') &&
                    createPasswordForm.get('password').touched
                  "
                >
                  <div class="error">
                    Password must be at least 8 characters
                  </div>
                </div>
              </div>
              <div class="form-group">
                <input
                  type="password"
                  placeholder="Confirm Password"
                  formControlName="confirmPassword"
                  class="form-control email-input"
                  name="confirmPassword"
                  required
                />
                <div
                  *ngIf="
                    createPasswordForm
                      .get('confirmPassword')
                      .hasError('required') &&
                    createPasswordForm.get('confirmPassword').touched
                  "
                >
                  <div class="error">Please enter confirm password</div>
                </div>
                <div
                  *ngIf="
                    createPasswordForm
                      .get('confirmPassword')
                      .hasError('minlength') &&
                    createPasswordForm.get('confirmPassword').touched
                  "
                >
                  <div class="error">
                    password must be at least 8 characters
                  </div>
                </div>

                <div *ngIf="mismatch">
                  <div class="error">password does not match</div>
                </div>
              </div>
              <!-- </div> -->
              <div class="text-center">
                <button class="RGARRButton" (click)="submit()">SUBMIT</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

<div *ngIf="successMsg" class="margin-auto">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-6 col-lg-offset-5 col-xl-5">
          <div class="border forBoarder">
            <div class="login-lable">
              <div class="text-center CreatedPassword">
               {{status_message}}
              </div>
            </div>
            <div class="text-center forLogin">Please click below to login</div>

            <div class="text-center forLoginButtion">
              <a>
                <button
                  type="button"
                  class="RGARRButton"
                  (click)="key_service?.login()" 
                >
                  LOGIN
                </button></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
